import React from 'react';

interface EmptyVideosProps {
    icon: string;
    title?: string;
    description?: string;
}

const EmptyVideos: React.FC<EmptyVideosProps> = ({ title, description, icon }) => {
    return (
        <div className="text-center py-12">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full mb-4">
                <svg
                    className="h-6 w-6 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d={icon}
                    />
                </svg>
            </div>
            <p className="text-gray-600 mb-2">{title}</p>
            <p className="text-gray-500 text-sm">
                {description}
            </p>
        </div>
    );
};

export default EmptyVideos;